import utils from "../utils/utils";

/**
 * Recovery Password Rest Client targeting backend REST API
 * @ngInject
 */
export default (Restangular) => {
	let jwt = null;
	let baseApi = Restangular.all("recovery-password");

	const getDeviceInfosHeaders = () => {
		const deviceInfosStr = sessionStorage.getItem('deviceInfos')
		const deviceInfos = JSON.parse(deviceInfosStr)
		return {
			'app-version': deviceInfos.appVersion,
			'device-id': deviceInfos.deviceId,
			'device-model': deviceInfos.deviceModel,
			'device-name': deviceInfos.deviceName,
			'device-brand': deviceInfos.deviceBrand,
			'os-name': deviceInfos.osName,
			'os-version': deviceInfos.osVersion
		};
	}

	/**
	 * Encapsulate all requests and extract token in case of success
	 * @param promise
	 */
	const requestInterceptor = (promise) => {
		return new Promise((resolve, reject) => {
			promise.then((response) => {
				jwt = response.headers("jwt-token");
				const headers = {
					...Restangular.defaultHeaders,
					...getDeviceInfosHeaders()
				}
				if (!utils.isEmpty(jwt)){
					headers.Authorization = jwt
				}
				Restangular.setDefaultHeaders(headers);
				resolve(response);
			}, (err) => {
				reject(err);
			});
		});
	};

	/**
	 * 1. Init the process of password recovery
	 */
	const initRecoverPasswordProcess = (personalData) => {
		Restangular.setDefaultHeaders({...Restangular.defaultHeaders, ...getDeviceInfosHeaders()});
		return requestInterceptor(baseApi.all("init-password-recovery-process").post(personalData));
	};

	/**
	 * 2. Confirm email token
	 */
	const confirmEmailVerificationToken = (token) => {
		return requestInterceptor(baseApi.all("confirm-email-verification-token").post(token));
	};

	/**
	 * 3. Send sms token
	 */
	const sendSmsToken = () => {
		return requestInterceptor(baseApi.all("send-sms-verification-token").post());
	};

	const sendNewSmsToken = (idProcesso) => {
		return baseApi.all("send-new-sms-verification-token").post(idProcesso);
	};

	const sendNewWhatsAppToken = (idProcesso) => {
		return baseApi.all("send-new-whatsapp-verification-token").post(idProcesso);
	};

	/**
	 * 4. Confirm sms token
	 */
	const confirmSmsToken = (token) => {
		return requestInterceptor(baseApi.all("confirm-sms-verification-token").post(token));
	};

    /**
	 * 5. Retrieve a set o unanswered security questions
     * @returns promise
     */
    const retrieveSecurityQuestions = () => {
        let all = baseApi.all("security-questions");
        return requestInterceptor(all.get(""));
    };

    /**
     * 6. Check all answers
     * @returns promise
     */
    const checkAnsweredSecurityQuestion = (securityQuestions) => {
        let all = baseApi.all("check-answered-security-question");
        return requestInterceptor(all.post(securityQuestions));
    };

    /**
     * 7. Change Associado's password
     * @returns promise
     */
    const changePassword = (changePasswordObj) => {
        let all = baseApi.all("change-password");
        return requestInterceptor(all.post(changePasswordObj));
    };

    /**
	 * 8. Block the chanel's passwords
	 * @returns promise
    */
    const blockPassword = (blockPasswordObj) =>{
    	return requestInterceptor(baseApi.all("block-password").post(blockPasswordObj));
    }

	return {
		initRecoverPasswordProcess,
		confirmEmailVerificationToken,
		sendSmsToken,
		sendNewSmsToken,
		sendNewWhatsAppToken,
		confirmSmsToken,
        retrieveSecurityQuestions,
        checkAnsweredSecurityQuestion,
        changePassword,
        blockPassword
	};
};


// WEBPACK FOOTER //
// ./src/app/misc/services/recoveryPassword.service.js